import { SkeletonDisplayText, SkeletonThumbnail } from "@shopify/polaris";
import React from "react";
import style from "../../../../scss/module/product_sku.module.scss";

export function SketonProduct({ rowsCount }: { rowsCount: number }) {
  return (
    <div>
      {[...new Array(rowsCount)].map((x) => {
        return (
          <div key={x}>
            <div className={style.basic_product}>
              <div className={style.info}>
                <div className="ml-4" style={{ paddingLeft: 12 }}>
                  <SkeletonThumbnail size="small" />
                </div>
                <div className="ml-3" style={{ width: 250 }}>
                  <SkeletonDisplayText size="small" />
                </div>
              </div>
            </div>
            <div className={style.basic_product}>
              <div className={style.sku}>
                <div className="ml-5" style={{ width: 250, paddingLeft: 12 }}>
                  <SkeletonDisplayText size="small" />
                </div>
              </div>
              <div className={style.qty} style={{ paddingLeft: 36 }}>
                <SkeletonDisplayText size="small" />
              </div>
              <div className={style.price}>
                <SkeletonDisplayText size="small" />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
